import React from 'react';
import JeeAdvancedResults2026 from '../views/JeeAdvancedResults2026';

const JeeAdvancedResults2026Page = () => <JeeAdvancedResults2026 />;

export default JeeAdvancedResults2026Page;
